<img class="logo" src="../../../assets/img/oms-logo.png" />

<div class="name">
    {{environmentName}}
</div>

<button mat-flat-button color="primary" (click)="login()">
    <span translate>Login</span>
</button>